import React, { useState, useEffect, useRef } from "react";
import { isRequired } from "./BriefUtils";
import BriefDropdownList from "../../components/BriefDropDownList/BriefDropdownList";
import BriefDateDropdown from "../../components/BriefDropDownList/BriefDateDropdown";
import { Globals } from "../../global/Globals";
import TextArea from "../../components/TextArea/TextArea";
import BriefFormGroup from "./BriefFormGroup";
import { getAllCriteria } from "../../services/createBriefAPI";
import { setIsCEDeadlineClicked, setIsEvalDetailsAtLeastPartiallyFilled } from "../NewBrief/CreateBriefSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLanguage } from '../../context/Languagecontext';

export const EvaluationInformationUI = ({
  handleTitleSelection,
  handleDate,
  handleTextArea,
  checkData,
  saveAction,
  addCriterionAction,
  handleCheckbox,
  hanleEvaluationData,
  propsData,
  isCloseDateChange,
}) => {
   const { Globals } = useLanguage();
  const [formData, setFormData] = useState({
    COMMISSIONING_EDITORS: propsData?.commisioningEditors || [],
    CE_EVALUATION_DEADLINE: propsData?.ceEvalDeadline
      ? new Date(propsData?.ceEvalDeadline)
      : "",
    SENIOR_MANAGER_EVALUATION_DEADLINE: propsData?.smEvalDeadline
      ? new Date(propsData?.smEvalDeadline)
      : "",
    EVALUATION_PROCESS: propsData?.evalAndSelection || "",
    CRITERIA: propsData?.criteriaIds || [],
    EXTRA_CRITERIA:
      propsData?.customCriteriaList &&
      propsData?.customCriteriaList.length !== 0
        ? propsData?.customCriteriaList
        : [
            {
              customCriteriaId: 0,
              customCriteriaName: "",
            },
          ],
  });

  const [criteriaValues, setCriteriaValues]=useState([]);
  const isSaveAsDraftClicked = useSelector(state => state.createBrief.isSaveAsDraftClicked);
  const isEvalDetailsValid =  useSelector(state => state.createBrief.isEvalDetailsValid);
  const isCEDeadlineClicked = useSelector(state => state.createBrief.isCEDeadlineClicked);
  const criteriaList = [
    "Originality",
    "Clarity",
    "Narrative Pace",
    "Characters",
    "Structure",
    "Relevance",
    "Creativity",
    "Emotional Impact",
    "Technical quality",
    "Consistency",
  ];
  const [data, setData] = useState([]);
  const [inValidateMandatoryField, setInValidateMandatoryField] = useState({
    isCEListInValid: false,
    isCEDeadlineInValid: false,
    isSMEvalDeadlineInValid: false,
    isEvalCriteriaInvalid: false
  });

  const dispatch = useDispatch();
  const validateCEList = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isCEListInValid: (formData.COMMISSIONING_EDITORS.length === 0) ? true : false
    }))
  }

  const validateCEDeadline = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isCEDeadlineInValid: (formData.CE_EVALUATION_DEADLINE === null || formData.CE_EVALUATION_DEADLINE === "") ? true : false
    }))
  }

  const validateSMEvalDeadline = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isSMEvalDeadlineInValid: formData.SENIOR_MANAGER_EVALUATION_DEADLINE === null || formData.SENIOR_MANAGER_EVALUATION_DEADLINE === "" ? true : false
    }))
  }

  const validateEvalCriteria = (data) => {
    if (data!==undefined) {
      setInValidateMandatoryField((prevState) => ({
        ...prevState,
        isEvalCriteriaInvalid: (data.length === 0) ? true : false
      }))
    }
    else {
      setInValidateMandatoryField((prevState) => ({
        ...prevState,
        isEvalCriteriaInvalid: false
      }))
    }
  }

  const serviceCall = async () => {
    try {
      const response = await getAllCriteria();
      setData(response.data.content);
    } catch (error) {}
  };
  useEffect(() => {
    serviceCall();
  }, []);

  useEffect(() => {
    hanleEvaluationData(formData);
  }, [formData]);

  useEffect(() => {
    if (!isCloseDateChange) return;
    setFormData((prevData) => ({
      ...prevData,
      SENIOR_MANAGER_EVALUATION_DEADLINE: null,
      CE_EVALUATION_DEADLINE: null,
    }));
  }, [isCloseDateChange]);

  const onDateChange = (name, value) => {
    if (name === "CE_EVALUATION_DEADLINE"){
      setFormData((prevData) => ({
        ...prevData,
        SENIOR_MANAGER_EVALUATION_DEADLINE: null,
        [name]: value,
      }));
      validateCEDeadline();
    }
    else{
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
     validateSMEvalDeadline();
     resetErrorOnChange(name);
    }
  };

  const handleSelect = (dropdownName, selectedValues) => {
    setFormData((prevData) => ({
      ...prevData,
      [dropdownName]: selectedValues,
    }));
    resetErrorOnChange(dropdownName);
  };

  const handleTextAreaChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    resetErrorOnChange(name);
  };

  const handleDateChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEvaluationCriteria = (data) => {
    setFormData((prevData) => ({
      ...prevData,
      ...data,
    }));
    setCriteriaValues(data?.CRITERIA);
    validateEvalCriteria(data?.CRITERIA);
  };

  const checkForClosingDate = () => {
    dispatch(setIsCEDeadlineClicked({ isCEDeadlineClicked: true }));
  }

  // useEffect(() => {
  //   if (isSaveAsDraftClicked === true && isEvalDetailsValid === false) {
  //     validateCEDeadline();
  //     validateCEList();
  //     validateSMEvalDeadline();
  //     validateEvalCriteria();
  //   }
  // }, [isEvalDetailsValid, isSaveAsDraftClicked])

  useEffect(() => {
    const doesFormHaveValue = formData.CE_EVALUATION_DEADLINE !== "" || formData.COMMISSIONING_EDITORS.length > 0 ||
      formData.SENIOR_MANAGER_EVALUATION_DEADLINE !== "" || formData.EVALUATION_PROCESS.length > 0 ||
      formData.CRITERIA.length > 0;
    dispatch(setIsEvalDetailsAtLeastPartiallyFilled({ isEvaluationPartiallyFilled: doesFormHaveValue }))
  })

  const resetErrorOnChange=(fieldName)=>{
    console.log("fieldName ===> ", fieldName);
    switch (fieldName){
      case 'CHANNEL': setInValidateMandatoryField((prevState)=>({...prevState, isChannelInValid:false})); break;
      case 'LANGUAGE': setInValidateMandatoryField((prevState)=>({...prevState, isLanguageInValid:false})); break;
      case 'GENRE': setInValidateMandatoryField((prevState)=>({...prevState, isGenreInValid:false})); break;
      case 'FORMAT': setInValidateMandatoryField((prevState)=>({...prevState, isFormatInValid:false})); break;
      case 'PRODUCTION_TYPE': setInValidateMandatoryField((prevState)=>({...prevState, isDescriptionInValid:false})); break;
      case 'SUBMISSION_REQUIREMENT': setInValidateMandatoryField((prevState)=>({...prevState, isSubmissionRequirementInValid:false})); break;
      case 'CLOSING_DATE': setInValidateMandatoryField((prevState)=>({...prevState, isClosingDateInValid:false})); break;
    }
  }
  return (
    <div className="brief-container">
      <label className="brief-basic-details-text">
        {Globals.CREATE_NEW_BRIEF.EVALUATION_INFORMATION}
      </label>
      <>
        <div className="brief-form-row">
          <div className="brief-form-group">
            {isRequired(Globals.CREATE_NEW_BRIEF.COMMISSIONING_EDITORS)}
            <span onBlur={validateCEList} tabIndex={9}>
            <BriefDropdownList
              name="COMMISSIONING_EDITORS"
              value={formData.COMMISSIONING_EDITORS}
              filterName="COMMISSIONING_EDITORS"
              title=" "
              isDatePicker={false}
              onSelect={handleSelect}
              className="dropdown-width-300"
            />
            {(inValidateMandatoryField.isCEListInValid && formData.COMMISSIONING_EDITORS.length===0)&&<div className="create-edit-BriefDateHolder"><img id="login-error" className="error-icon-brief-screen" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.CE_LIST}</label></div>}
            </span>
          </div>
          <div className="brief-form-group">
            <span tabIndex={10} onBlur={validateCEDeadline} onClick={checkForClosingDate}>
            <BriefDateDropdown
              inputLabel={Globals.CREATE_NEW_BRIEF.CE_EVALUATION_DEADLINE}
              placeholderText=" "
              name="CE_EVALUATION_DEADLINE"
              disabled={!!!checkData?.CLOSING_DATE}
              minDate={checkData?.CLOSING_DATE}
              onDateChange={onDateChange}
              selectedDate={formData?.CE_EVALUATION_DEADLINE}
            />
            {(inValidateMandatoryField.isCEDeadlineInValid&&(formData?.CE_EVALUATION_DEADLINE===null || formData.CE_EVALUATION_DEADLINE===""))&&<div className="create-edit-BriefDateHolder"><img id="login-error" className="error-icon-brief-screen" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.CE_EVAL_DEADLINE}</label></div>}
            </span>
          </div>
          <div className="brief-form-group">{/* Empty column */}</div>
        </div>
        <div className="brief-form-row">
          <div className="brief-form-group">
            <span tabIndex={11} onBlur={validateSMEvalDeadline} onClick={validateCEDeadline} >
            <BriefDateDropdown
              inputLabel={
                Globals.CREATE_NEW_BRIEF.SENIOR_MANAGER_EVALUATION_DEADLINE
              }
              name="SENIOR_MANAGER_EVALUATION_DEADLINE"
              placeholderText=" "
              disabled={!!!checkData?.CE_EVALUATION_DEADLINE}
              minDate={checkData?.CE_EVALUATION_DEADLINE}
              onDateChange={onDateChange}
              selectedDate={formData?.SENIOR_MANAGER_EVALUATION_DEADLINE}
            />
            {(inValidateMandatoryField.isSMEvalDeadlineInValid && (formData.SENIOR_MANAGER_EVALUATION_DEADLINE===null||formData.SENIOR_MANAGER_EVALUATION_DEADLINE===""))&&<div className="create-edit-BriefDateHolder"><img id="login-error" className="error-icon-brief-screen" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.SM_EVAL_DEADLINE}</label></div>}
            </span>
          </div>
          <div className="brief-form-group">{/* Empty column */}</div>
          <div className="brief-form-group">{/* Empty column */}</div>
        </div>
      </>
      <div className="brief-form-row">
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.EVALUATION_PROCESS, false)}
          <TextArea
            value={formData.EVALUATION_PROCESS}
            placeHolder=''
            textAreaInput={(value) =>
              handleTextAreaChange("EVALUATION_PROCESS", value)
            }
            className={`dropdown-width-300 brief-text-area ${
              formData.EVALUATION_PROCESS ? "brief-text-area-selected" : ""
            }`}
          />
        </div>
        <div className="brief-form-group">{/* Empty column */}</div>
        <div className="brief-form-group">{/* Empty column */}</div>
      </div>
      <BriefFormGroup
        criteriaList={data}
        value={propsData}
        saveAction={() => saveAction}
        addCriterionAction={() => addCriterionAction}
        handleCheckboxAction={(value) => handleCheckbox(1, value)}
        handleEvaluationCriteria={(formData) =>
          handleEvaluationCriteria(formData)
        }
      />
      <span>
        {(inValidateMandatoryField.isEvalCriteriaInvalid)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.EVAL_CRITERIA}</label></div>}
      </span>
    </div>
  );
};
